"use client"

import type React from "react"
import { useEffect } from "react"
import dynamic from "next/dynamic"
import { ModalProvider } from "@/context/modal-context"
import Navbar from "@/components/navbar"
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/next"

// Lazy load footer and popup components
const Footer = dynamic(() => import("@/components/footer"), {
  ssr: true,
})

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode
}) {
  useEffect(() => {
    const handleError = (e: ErrorEvent) => {
      if (e.filename && e.filename.includes("_next/static/chunks")) {
        console.warn("[v0] Skipped missing chunk:", e.filename)
        e.preventDefault()
      }
    }

    window.addEventListener("error", handleError)
    return () => window.removeEventListener("error", handleError)
  }, [])

  return (
    <ModalProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">{children}</main>
        <Footer />
      </div>
      <Analytics />
      <SpeedInsights />
    </ModalProvider>
  )
}
